import { Text } from "@instructure/ui";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CycleTypeService } from "../../services/CyclesService";
import { Selector } from "./Selector";

export const CycleTypeSelect = ({ selectHandler, selectedCycleType }) => {
  const { t } = useTranslation();
  const [types, setTypes] = useState([]);

  useEffect(() => {
    CycleTypeService.getCycleTypes().then((cycleTypes) => {
      cycleTypes.forEach((cycleType) => {
        cycleType.label = cycleType.name;
      });
      setTypes(cycleTypes);
    });
  }, []);

  const selectWrapper = (typeId) => {
    let selectedType = types.find((type) => type.id === typeId);
    selectHandler(selectedType);
  };

  return (
    <Selector
      label={<Text size="small">{t("cyclesAndGoals.typeSelect.label")}</Text>}
      assistiveText={t("cyclesAndGoals.typeSelect.assistiveText")}
      selectHandler={selectWrapper}
      options={types ? types : []}
      selectedItemId={
        selectedCycleType && Object.hasOwn(selectedCycleType, "id")
          ? selectedCycleType.id
          : ""
      }
    />
  );
};
